import { BASE_CHAIN_ID_NUMBER, BNToNumber } from '@mprolab/sdk'
import { BigNumber, utils } from 'ethers'
import { useState } from 'react'
import { useMproTokenContractAddress, useUSDCContractAddress, useUniswapRouterAddress } from 'state/global/hooks'
import { useUniswapRouterContract } from './useContract'
import { getUniswapRouterContract } from 'utils/contractHelpers'

export const useGetMproPrice = () => {
  const mproContractAddresses = useMproTokenContractAddress()
  const uniswapRouterContractAddresses = useUniswapRouterAddress()
  const usdContractAddresses = useUSDCContractAddress()
  const [mproPriceLoading, setMproPriceLoading] = useState<boolean>(true)

  const getMproPrice = async (amount: BigNumber, chainId: number, removeDust?: boolean) => {
    const mproToken = mproContractAddresses?.find((contract) => contract.chainId === chainId)
    const routerContract = uniswapRouterContractAddresses?.find((contract) => contract.chainId === chainId)
    const usdContract = usdContractAddresses?.find((contract) => contract.chainId === chainId)
    if (!amount || !mproToken?.address || !routerContract?.address || !usdContract?.address) {
      setMproPriceLoading(false)
      return null
    }
    const { address: mproTokenAddress } = mproToken
    const router = getUniswapRouterContract(routerContract.address, undefined, chainId)
    try {
      const WETH_CONTRACT_ADDRESS = await router.WETH()
      const USDC_CONTRACT_ADDRESS = usdContract?.address
      const path = [mproTokenAddress, WETH_CONTRACT_ADDRESS, USDC_CONTRACT_ADDRESS]
      const amountsOut = await router.getAmountsOut(amount, path)
      const usdcPrice = BNToNumber(amountsOut[2], 6)

      if (removeDust && usdcPrice < 0.01) {
        return 0
      }
      return usdcPrice
    } catch (error) {
      return null
    } finally {
      setMproPriceLoading(false)
    }
  }

  return {
    getMproPrice,
    mproPriceLoading
  }
}
